import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { get } from "../../lib/sessionClient";
import { clearLocalStorageSession } from "../../lib/authUtils";

const useGetData = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState("");

  const getData = async (apiEndPoint) => {
    try {
      const response = await get(apiEndPoint);
      setData(response.data);
    } catch (error) {
      if (error.response?.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        setError(error.response?.data?.message || error.message);
      }
    } finally {
      setIsLoaded(true);
    }
  };

  return {
    data,
    isLoaded,
    error,
    getData,
    setIsLoaded,
    setError,
    setData,
  };
};

export default useGetData;
